module.exports = __webpack_public_path__ + "static/media/our-company-main-banner.ad34f776.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/our-companies/our-company-main-banner.png
// module id = 93
// module chunks = 0